// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"pL-z","smallCardRow":"qL-z","largeCardRow":"rL-z","productSearchRow":"sL-z","curatedRow":"tL-z"};